import { useEffect, useRef } from 'react';

// Ensure the function is only run once after the component mounts even under strict mode
export const useRunOnceAfterMount = (func: () => void) => {
    const hasRun = useRef(false);
    useEffect(() => {
        if (!hasRun.current) {
            func();
        }
        hasRun.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
